import { Pages, Containers } from '@briq/core'

export function useCheckoutConfig(): Pages.CheckoutConfig {
  return {
    displayRegistrationNumber: true,
    displayTaxCode: false,
    hideInvestigationFormLink: false,
    displayDocumentUpload: false,
    sideBanner: Containers.Checkout.CollapsibleItemSideBanner
  }
}
